import { ChevronDown } from "react-feather";
import styles from "../communication-chat.module.css";

const EmployeeList = (props) => {
  const formatPhoneNumber = (phoneNumber) => {
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return cleaned;
  };

  const getInitials = (firstName, lastName) => {
    const first = firstName ? firstName.charAt(0).toUpperCase() : "";
    const last = lastName ? lastName.charAt(0).toUpperCase() : "";
    return first + last || "?";
  };

  const getAvatarUrl = (user_image_url) => {
    if (!user_image_url || user_image_url === "") return null;
    return `${process.env.REACT_APP_USER_IMAGE_BASE_URL}${user_image_url}`;
  };

  const sortedEmployeeList = [...props.employeeList].sort((a, b) => {
    const nameA = a.first_name ? a.first_name.toLowerCase() : a.phone;
    const nameB = b.first_name ? b.first_name.toLowerCase() : b.phone;
    return nameA.localeCompare(nameB);
  });

  const getRoleBadgeClass = (role) => {
    if (!role) return styles.NotApplied;
    const r = role.toLowerCase();
    if (r.includes("admin") || r.includes("manager")) return styles.Approved;
    if (r.includes("technician") || r.includes("maintenance"))
      return styles.Screened;
    if (r.includes("security")) return styles.Applied;
    return styles.NotApplied;
  };

  return (
    <>
      <div
        onClick={() => props.toggleAccordionForEmployee()}
        className={
          props.accordionOnForEmployee
            ? `${styles.accordionOn} ${styles.Open}`
            : `${styles.accordionOn}`
        }
      >
        <p className={`${styles.ListAccoudionTitle}`}>
          <ChevronDown /> Employees <span>{props.employeeList.length}</span>
        </p>

        <div>
          {sortedEmployeeList.length > 0 &&
            sortedEmployeeList.map((employee, i) => {
              return (
                <div
                  key={i}
                  className={
                    employee.id === props?.prospectTenantDetails?.id &&
                    props?.prospectTenantDetails?.type === "Employee"
                      ? `${styles.activeTenant} ${styles.CommuListSec}`
                      : `${styles.CommuListSec}`
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    props.setDetails(employee);
                  }}
                >
                  <div className={`${styles.EmployeeListDeSecNormal}`}>
                    <div className={`${styles.EmployeeAvatarSec}`}>
                      {getAvatarUrl(employee?.user_image_url) ? (
                        <img
                          src={getAvatarUrl(employee.user_image_url)}
                          alt=""
                          className={`${styles.EmpAvatarImg}`}
                        />
                      ) : (
                        <p className={`${styles.EmpAvatarInitials}`}>
                          {getInitials(employee.first_name, employee.last_name)}
                        </p>
                      )}
                      {employee?.is_online === 1 && (
                        <span
                          className={`${styles.StatusBadge} ${styles.Online}`}
                        ></span>
                      )}
                      {employee?.is_online !== 1 && (
                        <span className={`${styles.StatusBadge}`}></span>
                      )}
                    </div>
                    <div>
                      <p className={`${styles.ProsTenantList}`}>
                        {employee?.first_name ? (
                          <span>
                            {employee?.first_name}&nbsp;{employee?.last_name}
                          </span>
                        ) : (
                          <span>{formatPhoneNumber(employee?.phone)}</span>
                        )}
                      </p>
                      <p className={`${styles.ProsTenantListDe}`}>
                        <span>{employee?.property_name}</span>
                        {employee?.role && <span>{employee.role}</span>}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        {sortedEmployeeList.length === 0 && (
          <div className={`${styles.NoDataSecOnlyText}`}>
            <img src="/static/img/chatIcon.png" alt="" />
            <p>No employee here!</p>
          </div>
        )}
      </div>
    </>
  );
};

export default EmployeeList;
